import "./index.css";
import "./i18n/config";

import { PostHogProvider } from "@posthog/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import posthog from "posthog-js";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { Toaster } from "sonner";

import { LanguageInitializer } from "./components/features/settings/LanguageInitializer";
import { router } from "./config/routes";
import { initAnalytics } from "./lib/analytics";
import { setOnUnauthorized } from "./lib/api";

initAnalytics();

const root = document.getElementById("root");
if (!root) throw new Error("Root element #root not found");

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000,
			gcTime: 15 * 60 * 1000,
		},
	},
});

setOnUnauthorized(() => {
	void router.navigate("/auth/login", { replace: true });
});

createRoot(root).render(
	<>
		<Toaster position="bottom-right" />
		<QueryClientProvider client={queryClient}>
			<StrictMode>
				<LanguageInitializer>
					<PostHogProvider client={posthog}>
						<RouterProvider router={router} />
					</PostHogProvider>
				</LanguageInitializer>
			</StrictMode>
		</QueryClientProvider>
	</>,
);
